"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _CreateTariffChargeMultiplier = _interopRequireDefault(require("./CreateTariffChargeMultiplier"));
var _CreateTariffChargeSeason = _interopRequireDefault(require("./CreateTariffChargeSeason"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * The CreateTariffCharge model module.
 * @module model/CreateTariffCharge
 * @version 0.1.0
 */
var CreateTariffCharge = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>CreateTariffCharge</code>.
   * @alias module:model/CreateTariffCharge
   * @param name {String} 
   * @param type {Number} Type of the charge - Purchase: 1, Feed-In: 2.
   * @param chargeTypeUnitId {Number} Unit of the charge type which determines how the pricing is calculated.
   * @param status {Number} Enabled: 1, Disabled: 2.
   */
  function CreateTariffCharge(name, type, chargeTypeUnitId, status) {
    _classCallCheck(this, CreateTariffCharge);
    CreateTariffCharge.initialize(this, name, type, chargeTypeUnitId, status);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  _createClass(CreateTariffCharge, [{
    key: "getName",
    value:
    /**
         * @return {String}
         */
    function getName() {
      return this.name;
    }

    /**
     * @param {String} name
     */
  }, {
    key: "setName",
    value: function setName(name) {
      this['name'] = name;
    }
    /**
         * @return {String}
         */
  }, {
    key: "getDescription",
    value: function getDescription() {
      return this.description;
    }

    /**
     * @param {String} description
     */
  }, {
    key: "setDescription",
    value: function setDescription(description) {
      this['description'] = description;
    }
    /**
         * Returns Type of the charge - Purchase: 1, Feed-In: 2.
         * @return {Number}
         */
  }, {
    key: "getType",
    value: function getType() {
      return this.type;
    }

    /**
     * Sets Type of the charge - Purchase: 1, Feed-In: 2.
     * @param {Number} type Type of the charge - Purchase: 1, Feed-In: 2.
     */
  }, {
    key: "setType",
    value: function setType(type) {
      this['type'] = type;
    }
    /**
         * Returns Tag to group similar charges together.
         * @return {String}
         */
  }, {
    key: "getGroup",
    value: function getGroup() {
      return this.group;
    }

    /**
     * Sets Tag to group similar charges together.
     * @param {String} group Tag to group similar charges together.
     */
  }, {
    key: "setGroup",
    value: function setGroup(group) {
      this['group'] = group;
    }
    /**
         * Returns Order to display within the group.
         * @return {Number}
         */
  }, {
    key: "getDisplayOrder",
    value: function getDisplayOrder() {
      return this.displayOrder;
    }

    /**
     * Sets Order to display within the group.
     * @param {Number} displayOrder Order to display within the group.
     */
  }, {
    key: "setDisplayOrder",
    value: function setDisplayOrder(displayOrder) {
      this['displayOrder'] = displayOrder;
    }
    /**
         * Returns Unit of the charge type which determines how the pricing is calculated.
         * @return {Number}
         */
  }, {
    key: "getChargeTypeUnitId",
    value: function getChargeTypeUnitId() {
      return this.chargeTypeUnitId;
    }

    /**
     * Sets Unit of the charge type which determines how the pricing is calculated.
     * @param {Number} chargeTypeUnitId Unit of the charge type which determines how the pricing is calculated.
     */
  }, {
    key: "setChargeTypeUnitId",
    value: function setChargeTypeUnitId(chargeTypeUnitId) {
      this['chargeTypeUnitId'] = chargeTypeUnitId;
    }
    /**
         * Returns Price of a unit. Only used if a season for the period is not provided.
         * @return {Number}
         */
  }, {
    key: "getUnitPrice",
    value: function getUnitPrice() {
      return this.unitPrice;
    }

    /**
     * Sets Price of a unit. Only used if a season for the period is not provided.
     * @param {Number} unitPrice Price of a unit. Only used if a season for the period is not provided.
     */
  }, {
    key: "setUnitPrice",
    value: function setUnitPrice(unitPrice) {
      this['unitPrice'] = unitPrice;
    }
    /**
         * Returns Discount amount to apply to the quantity before price calculation. Only used if a season for the period is not provided.
         * @return {Number}
         */
  }, {
    key: "getUnitDiscount",
    value: function getUnitDiscount() {
      return this.unitDiscount;
    }

    /**
     * Sets Discount amount to apply to the quantity before price calculation. Only used if a season for the period is not provided.
     * @param {Number} unitDiscount Discount amount to apply to the quantity before price calculation. Only used if a season for the period is not provided.
     */
  }, {
    key: "setUnitDiscount",
    value: function setUnitDiscount(unitDiscount) {
      this['unitDiscount'] = unitDiscount;
    }
    /**
         * Returns Time of the day (HH:mm) when the charge applies for standard times (weekdays). For all-day make the start and end-time the same. Only applicable to energy-based charges.
         * @return {String}
         */
  }, {
    key: "getPeriodStart",
    value: function getPeriodStart() {
      return this.periodStart;
    }

    /**
     * Sets Time of the day (HH:mm) when the charge applies for standard times (weekdays). For all-day make the start and end-time the same. Only applicable to energy-based charges.
     * @param {String} periodStart Time of the day (HH:mm) when the charge applies for standard times (weekdays). For all-day make the start and end-time the same. Only applicable to energy-based charges.
     */
  }, {
    key: "setPeriodStart",
    value: function setPeriodStart(periodStart) {
      this['periodStart'] = periodStart;
    }
    /**
         * Returns Time of the day (HH:mm) when the charge finishes for standard times (weekdays). Only applicable to energy-based charges.
         * @return {String}
         */
  }, {
    key: "getPeriodEnd",
    value: function getPeriodEnd() {
      return this.periodEnd;
    }

    /**
     * Sets Time of the day (HH:mm) when the charge finishes for standard times (weekdays). Only applicable to energy-based charges.
     * @param {String} periodEnd Time of the day (HH:mm) when the charge finishes for standard times (weekdays). Only applicable to energy-based charges.
     */
  }, {
    key: "setPeriodEnd",
    value: function setPeriodEnd(periodEnd) {
      this['periodEnd'] = periodEnd;
    }
    /**
         * Returns Time of the day (HH:mm) when the charge applies for special days (weekends and potentially public holidays). For all-day make the start and end-time the same. Only applicable to energy-based charges.
         * @return {String}
         */
  }, {
    key: "getAlternatePeriodStart",
    value: function getAlternatePeriodStart() {
      return this.alternatePeriodStart;
    }

    /**
     * Sets Time of the day (HH:mm) when the charge applies for special days (weekends and potentially public holidays). For all-day make the start and end-time the same. Only applicable to energy-based charges.
     * @param {String} alternatePeriodStart Time of the day (HH:mm) when the charge applies for special days (weekends and potentially public holidays). For all-day make the start and end-time the same. Only applicable to energy-based charges.
     */
  }, {
    key: "setAlternatePeriodStart",
    value: function setAlternatePeriodStart(alternatePeriodStart) {
      this['alternatePeriodStart'] = alternatePeriodStart;
    }
    /**
         * Returns Time of the day (HH:mm) when the charge finishes for special days (weekends and potentially public holidays). Only applicable to energy-based charges.
         * @return {String}
         */
  }, {
    key: "getAlternatePeriodEnd",
    value: function getAlternatePeriodEnd() {
      return this.alternatePeriodEnd;
    }

    /**
     * Sets Time of the day (HH:mm) when the charge finishes for special days (weekends and potentially public holidays). Only applicable to energy-based charges.
     * @param {String} alternatePeriodEnd Time of the day (HH:mm) when the charge finishes for special days (weekends and potentially public holidays). Only applicable to energy-based charges.
     */
  }, {
    key: "setAlternatePeriodEnd",
    value: function setAlternatePeriodEnd(alternatePeriodEnd) {
      this['alternatePeriodEnd'] = alternatePeriodEnd;
    }
    /**
         * Returns Enabled: 1, Disabled: 2.
         * @return {Number}
         */
  }, {
    key: "getStatus",
    value: function getStatus() {
      return this.status;
    }

    /**
     * Sets Enabled: 1, Disabled: 2.
     * @param {Number} status Enabled: 1, Disabled: 2.
     */
  }, {
    key: "setStatus",
    value: function setStatus(status) {
      this['status'] = status;
    }
    /**
         * @return {Array.<module:model/CreateTariffChargeMultiplier>}
         */
  }, {
    key: "getMultipliers",
    value: function getMultipliers() {
      return this.multipliers;
    }

    /**
     * @param {Array.<module:model/CreateTariffChargeMultiplier>} multipliers
     */
  }, {
    key: "setMultipliers",
    value: function setMultipliers(multipliers) {
      this['multipliers'] = multipliers;
    }
    /**
         * Returns Allows season-specific pricing which overrides the base pricing.
         * @return {Array.<module:model/CreateTariffChargeSeason>}
         */
  }, {
    key: "getSeasons",
    value: function getSeasons() {
      return this.seasons;
    }

    /**
     * Sets Allows season-specific pricing which overrides the base pricing.
     * @param {Array.<module:model/CreateTariffChargeSeason>} seasons Allows season-specific pricing which overrides the base pricing.
     */
  }, {
    key: "setSeasons",
    value: function setSeasons(seasons) {
      this['seasons'] = seasons;
    }
  }], [{
    key: "initialize",
    value: function initialize(obj, name, type, chargeTypeUnitId, status) {
      obj['name'] = name;
      obj['type'] = type;
      obj['chargeTypeUnitId'] = chargeTypeUnitId;
      obj['status'] = status;
    }

    /**
     * Constructs a <code>CreateTariffCharge</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CreateTariffCharge} obj Optional instance to populate.
     * @return {module:model/CreateTariffCharge} The populated <code>CreateTariffCharge</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new CreateTariffCharge();
        if (data.hasOwnProperty('name')) {
          obj['name'] = _ApiClient["default"].convertToType(data['name'], 'String');
        }
        if (data.hasOwnProperty('description')) {
          obj['description'] = _ApiClient["default"].convertToType(data['description'], 'String');
        }
        if (data.hasOwnProperty('type')) {
          obj['type'] = _ApiClient["default"].convertToType(data['type'], 'Number');
        }
        if (data.hasOwnProperty('group')) {
          obj['group'] = _ApiClient["default"].convertToType(data['group'], 'String');
        }
        if (data.hasOwnProperty('displayOrder')) {
          obj['displayOrder'] = _ApiClient["default"].convertToType(data['displayOrder'], 'Number');
        }
        if (data.hasOwnProperty('chargeTypeUnitId')) {
          obj['chargeTypeUnitId'] = _ApiClient["default"].convertToType(data['chargeTypeUnitId'], 'Number');
        }
        if (data.hasOwnProperty('unitPrice')) {
          obj['unitPrice'] = _ApiClient["default"].convertToType(data['unitPrice'], 'Number');
        }
        if (data.hasOwnProperty('unitDiscount')) {
          obj['unitDiscount'] = _ApiClient["default"].convertToType(data['unitDiscount'], 'Number');
        }
        if (data.hasOwnProperty('periodStart')) {
          obj['periodStart'] = _ApiClient["default"].convertToType(data['periodStart'], 'String');
        }
        if (data.hasOwnProperty('periodEnd')) {
          obj['periodEnd'] = _ApiClient["default"].convertToType(data['periodEnd'], 'String');
        }
        if (data.hasOwnProperty('alternatePeriodStart')) {
          obj['alternatePeriodStart'] = _ApiClient["default"].convertToType(data['alternatePeriodStart'], 'String');
        }
        if (data.hasOwnProperty('alternatePeriodEnd')) {
          obj['alternatePeriodEnd'] = _ApiClient["default"].convertToType(data['alternatePeriodEnd'], 'String');
        }
        if (data.hasOwnProperty('status')) {
          obj['status'] = _ApiClient["default"].convertToType(data['status'], 'Number');
        }
        if (data.hasOwnProperty('multipliers')) {
          obj['multipliers'] = _ApiClient["default"].convertToType(data['multipliers'], [_CreateTariffChargeMultiplier["default"]]);
        }
        if (data.hasOwnProperty('seasons')) {
          obj['seasons'] = _ApiClient["default"].convertToType(data['seasons'], [_CreateTariffChargeSeason["default"]]);
        }
      }
      return obj;
    }
  }]);
  return CreateTariffCharge;
}();
/**
 * @member {String} name
 */
CreateTariffCharge.prototype['name'] = undefined;

/**
 * @member {String} description
 */
CreateTariffCharge.prototype['description'] = undefined;

/**
 * Type of the charge - Purchase: 1, Feed-In: 2.
 * @member {Number} type
 */
CreateTariffCharge.prototype['type'] = undefined;

/**
 * Tag to group similar charges together.
 * @member {String} group
 */
CreateTariffCharge.prototype['group'] = undefined;

/**
 * Order to display within the group.
 * @member {Number} displayOrder
 */
CreateTariffCharge.prototype['displayOrder'] = undefined;

/**
 * Unit of the charge type which determines how the pricing is calculated.
 * @member {Number} chargeTypeUnitId
 */
CreateTariffCharge.prototype['chargeTypeUnitId'] = undefined;

/**
 * Price of a unit. Only used if a season for the period is not provided.
 * @member {Number} unitPrice
 */
CreateTariffCharge.prototype['unitPrice'] = undefined;

/**
 * Discount amount to apply to the quantity before price calculation. Only used if a season for the period is not provided.
 * @member {Number} unitDiscount
 */
CreateTariffCharge.prototype['unitDiscount'] = undefined;

/**
 * Time of the day (HH:mm) when the charge applies for standard times (weekdays). For all-day make the start and end-time the same. Only applicable to energy-based charges.
 * @member {String} periodStart
 */
CreateTariffCharge.prototype['periodStart'] = undefined;

/**
 * Time of the day (HH:mm) when the charge finishes for standard times (weekdays). Only applicable to energy-based charges.
 * @member {String} periodEnd
 */
CreateTariffCharge.prototype['periodEnd'] = undefined;

/**
 * Time of the day (HH:mm) when the charge applies for special days (weekends and potentially public holidays). For all-day make the start and end-time the same. Only applicable to energy-based charges.
 * @member {String} alternatePeriodStart
 */
CreateTariffCharge.prototype['alternatePeriodStart'] = undefined;

/**
 * Time of the day (HH:mm) when the charge finishes for special days (weekends and potentially public holidays). Only applicable to energy-based charges.
 * @member {String} alternatePeriodEnd
 */
CreateTariffCharge.prototype['alternatePeriodEnd'] = undefined;

/**
 * Enabled: 1, Disabled: 2.
 * @member {Number} status
 */
CreateTariffCharge.prototype['status'] = undefined;

/**
 * @member {Array.<module:model/CreateTariffChargeMultiplier>} multipliers
 */
CreateTariffCharge.prototype['multipliers'] = undefined;

/**
 * Allows season-specific pricing which overrides the base pricing.
 * @member {Array.<module:model/CreateTariffChargeSeason>} seasons
 */
CreateTariffCharge.prototype['seasons'] = undefined;
var _default = CreateTariffCharge;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@solarschools/api-sdk/dist/model/CreateTariffCharge.js
// module id = pLx4
// module chunks = 3